"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.reset.button': 'Ripristina Addestratore',
};
